import ApiBase from '@/api/api-base'
import {ACTIVE_BASE_REST} from '@/api/constants'

export default class SystemDictionary extends ApiBase {
    constructor(store) {
        const path = `${ACTIVE_BASE_REST}/dictionary`
        super(store, path)
    }
}